import React from "react";

const Coins = () => {
	return <div>Coins</div>;
};

export default Coins;
